import { useMutation } from '@tanstack/react-query';
import {
  ConnectPartPostError,
  ConnectPartPostParams,
  ConnectPartPostResponse,
} from '@/api/model/authentication/investor.ts';
import { BASE_URL_LANG } from '@/api/utils.ts';
import axios, { AxiosError, AxiosResponse } from 'axios';

const useConnectPartPost = () =>
  useMutation<
    AxiosResponse<ConnectPartPostResponse>,
    AxiosError<ConnectPartPostError>,
    ConnectPartPostParams
  >({
    mutationFn: ({ email, password, sec_token, sendLogin }) => {
      const body = new FormData();
      body.append('sendLogin', sendLogin);
      body.append('email', email);
      body.append('password', password);
      body.append('sec_token', sec_token);

      return axios.post(`${BASE_URL_LANG}connectpart`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Backend requires this header
          internal: 1,
        },
      });
    },
  });

export { useConnectPartPost };
